import { ngModuleRegistrar } from '../helpers';
import {
    HeaderComponent,
    InfoModalComponent,
} from '.';

export default ngModuleRegistrar('component', {
    [HeaderComponent.selector]: HeaderComponent,
    [InfoModalComponent.selector]: InfoModalComponent,
});



// WEBPACK FOOTER //
// ./src/app-modules/register.js